module.exports = __webpack_public_path__ + "static/saffronSharkLabs-330455cc3eb15473fea0a6abf08ce2af.png";